import { FAILURE, REQUEST, SUCCESS } from 'utils/actionTypeUtil';
import { API_URL } from 'constants/apiUrl';
import axios from 'axios';

const apiUrl = `${API_URL}/apbn_zone`;

export const ACTION_TYPES = {
  FETCH_APBNZONE_LIST: 'apbnzone/FETCH_APBNZONE_LIST',
  FETCH_APBNZONE: 'apbnzone/FETCH_APBNZONE',
  CREATE_APBNZONE: 'apbnzone/CREATE_APBNZONE',
  UPDATE_APBNZONE: 'apbnzone/UPDATE_APBNZONE',
  DELETE_APBNZONE: 'apbnzone/DELETE_APBNZONE',
  RESET: 'apbnzone/RESET',
};

const initial = {
  loading: false,
  errorMessage: null,
  updating: false,
  updateSuccess: false,
  entities: [],
  entity: {}, //defaultValue
};

// REDUCER
const apbnzoneReducer = (state = initial, action) => {
  switch (action.type) {
    case REQUEST(ACTION_TYPES.FETCH_APBNZONE_LIST):
    case REQUEST(ACTION_TYPES.FETCH_APBNZONE):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        loading: true,
      };
    case REQUEST(ACTION_TYPES.CREATE_APBNZONE):
    case REQUEST(ACTION_TYPES.UPDATE_APBNZONE):
    case REQUEST(ACTION_TYPES.DELETE_APBNZONE):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        updating: true,
      };
    case FAILURE(ACTION_TYPES.FETCH_APBNZONE_LIST):
    case FAILURE(ACTION_TYPES.FETCH_APBNZONE):
    case FAILURE(ACTION_TYPES.CREATE_APBNZONE):
    case FAILURE(ACTION_TYPES.UPDATE_APBNZONE):
    case FAILURE(ACTION_TYPES.DELETE_APBNZONE):
      return {
        ...state,
        loading: false,
        updating: false,
        updateSuccess: false,
        errorMessage: action.payload,
      };
    case SUCCESS(ACTION_TYPES.FETCH_APBNZONE_LIST):
      let res = action.payload.data;
      return {
        ...state,
        loading: false,
        entities: res,
      };
    case SUCCESS(ACTION_TYPES.FETCH_APBNZONE):
      return {
        ...state,
        loading: false,
        entity: action.payload.data,
      };
    case SUCCESS(ACTION_TYPES.CREATE_APBNZONE):
    case SUCCESS(ACTION_TYPES.UPDATE_APBNZONE):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: action.payload.data,
      };
    case SUCCESS(ACTION_TYPES.DELETE_APBNZONE):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: {},
      };
    case ACTION_TYPES.RESET:
      return { ...initial };
    default:
      return state;
  }
};

export default apbnzoneReducer;

// ACTIONS
export const getEntities = () => ({
  type: ACTION_TYPES.FETCH_APBNZONE_LIST,
  payload: axios.get(apiUrl),
});

export const getEntity = id => ({
  type: ACTION_TYPES.FETCH_APBNZONE,
  payload: axios.get(`${apiUrl}/${id}`),
});

export const createEntity = entity => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.CREATE_APBNZONE,
    payload: axios.post(apiUrl, entity),
    meta: { successMessage: `Berhasil simpan!` },
  });
  return result;
};

export const updateEntity = (entity, id) => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.UPDATE_APBNZONE,
    payload: axios.patch(`${apiUrl}/${id}`, entity),
    meta: { successMessage: `Berhasil update!` },
  });
  dispatch(getEntities());
  return result;
};

export const deleteEntity = id => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.DELETE_APBNZONE,
    payload: axios.delete(`${apiUrl}/${id}`),
    meta: { errorMessage: `Gagal hapus!`, successMessage: `Berhasil Hapus!` },
  });
  dispatch(getEntities());
  return result;
};

export const reset = () => ({
  type: ACTION_TYPES.RESET,
});
